import {
  addJobDetailsMetadata,
  getJobDetailsMetadata,
  type SolMetadata,
} from '@seek/sol-js';

export function setJobSolMetadata(solMetadata: SolMetadata) {
  return addJobDetailsMetadata([{ solMetadata }], window.localStorage);
}

export function getJobSolMetadata(jobId: string) {
  try {
    const queryParams = new URLSearchParams(
      window.location.search.toLowerCase(),
    );
    const searchRequestToken =
      queryParams.get('searchrequesttoken') ||
      '00000000-0000-4000-8000-000000000000';
    const token = queryParams.get('token') || undefined;
    const key = queryParams.get('sol') || undefined;
    const metadata = getJobDetailsMetadata({
      searchRequestToken,
      jobId,
      token,
      key,
    });

    return metadata;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return undefined;
  }
}
